var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-frame-container"},[_c('iframe',{staticClass:"gameFrame",attrs:{"id":"gameFrame","src":this.gameUrl},on:{"load":_vm.onLoadedComplete}})])
}
var staticRenderFns = []

export { render, staticRenderFns }